import { apiCall } from "../helpers/api";

export const pay_types = (params = {}) => dispatch => {
    params.path = params.path || "pay_types";
    return dispatch(apiCall(params));
}